module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vshou10-7d085abb30ba2d86f11eb1cd21ae6c45.jpg";